import React from 'react';
import { Modal } from '../../../components/common/Modal';
import { CreateItemForm } from '../../inventory/CreateItemForm';
import { useLanguage } from '../../../features/language/useLanguage';
import type { WorkOrder } from '../../../types/workOrder';
import type { InventoryItemFormData } from '../../../types/inventory';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  selectedWorkOrder: WorkOrder | null;
  finishedGoodInitialData: Partial<InventoryItemFormData> | null;
  finishedGoodMode: 'create' | 'update';
  onCreateFinishedGood: (data: InventoryItemFormData) => void | Promise<void>;
  canWrite?: boolean;
}

const buildFallbackInitialData = (workOrder: WorkOrder): Partial<InventoryItemFormData> => ({
  name:
    workOrder.recipeName && workOrder.recipeName !== 'Unknown Recipe'
      ? workOrder.recipeName
      : `Roasting ${workOrder.workOrderNumber ?? workOrder.id}`,
  code: undefined,
  itemType: 'roasted_bulk',
  workOrderId: workOrder.id,
  reorderPoint: 0,
  standardCost: 0,
  unitOfMeasure: 'kg',
  quantity: workOrder.outputWeight ?? 0,
  description: `Produced from Work Order #${workOrder.id}`,
  roastInputWeight: workOrder.inputWeight ?? 0,
});

export const MoveToInventoryModal: React.FC<Props> = ({
  isOpen,
  onClose,
  selectedWorkOrder,
  finishedGoodInitialData,
  finishedGoodMode,
  onCreateFinishedGood,
  canWrite = true,
}) => {
  const { t } = useLanguage();
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('workOrders.page.moveToInventory')} className="max-w-2xl">
      {selectedWorkOrder && (
        <CreateItemForm
          onSubmit={onCreateFinishedGood}
          onCancel={onClose}
          mode={finishedGoodMode}
          readOnly={!canWrite}
          initialData={finishedGoodInitialData || buildFallbackInitialData(selectedWorkOrder)}
        />
      )}
    </Modal>
  );
};
